module.exports = __webpack_public_path__ + "static/media/maxDailyLogin_90_120.e5c29c1e.png";